import React from 'react';
import { createRoot } from 'react-dom/client';
import './style/root.scss';
import './tw-input.css';
import AppStartupHandler from './components/base/app-startup-handler';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Landing from './components/base/landing';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './query-client';
import { createLDReactProvider } from '@launchdarkly/react-sdk';

import envConfig from './utils/env-config';

const LDProvider = createLDReactProvider(envConfig.launchDarklyClientId, {
  kind: 'user',
  anonymous: true,
});

if (import.meta.env.DEV) {
  window.LOG_LEVEL = 'DEBUG';
}

Object.defineProperty(global, 'connectSession', {
  value: null,
  writable: true,
});

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container missing in index.html');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <LDProvider>
      <BrowserRouter
        getUserConfirmation={() => {
          /* Empty callback to block the default browser prompt */
        }}
      >
        <Switch>
          <Route exact path="/">
            <Landing />
          </Route>
          <Route path="/app">
            <QueryClientProvider client={queryClient}>
              <AppStartupHandler />
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </Route>
        </Switch>
      </BrowserRouter>
    </LDProvider>
  </React.StrictMode>,
);
